import React from "react";
import { CpButton, CpInputField } from "canopy-styleguide!sofe";
import { useForm } from "react-hook-form";
import { useCss, k, a, m } from "kremling";

export function SetupMfaPhone(props) {
  const { mobile, navigate, sendPhoneCode } = props;
  const scope = useCss(css);

  const { handleSubmit, control, watch } = useForm({
    defaultValues: { phoneNumber: "" },
    mode: "onSubmit",
  });
  const phoneNumber = watch("phoneNumber");

  function submit(form) {
    sendPhoneCode(form.phoneNumber);
  }

  return (
    <div {...scope}>
      <div className="cp-mb-24">Enter your phone number in order to recieve a verification code</div>
      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(submit)();
        }}
      >
        <CpInputField
          fieldName="phoneNumber"
          control={control}
          type="tel"
          placeholder="Enter phone number"
          rules={{
            required: "Phone number is required",
          }}
        />

        <div className={a("cp-mt-40 cp-flex").m("mobile-button-group", mobile)}>
          <CpButton type="submit" disabled={!phoneNumber}>
            Next
          </CpButton>
          <CpButton btnType="secondary" onClick={() => navigate("mfa-selection")} className={m("cp-ml-16", !mobile)}>
            Back
          </CpButton>
        </div>
      </form>
    </div>
  );
}

const css = k`
  .mobile-button-group {
    display: flex;
    flex-direction: column;
    height: 12.8rem;
    justify-content: space-between;
  }

  .mobile-button-group .cp-button {
    width: 100%;
  }
`;
